/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Periodicity Attention List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PeriodicityAttentionListView';

export const mapStateToPropsPeriodicityAttentionList = mapStateToProps;
export const mapDispatchToPropsPeriodicityAttentionList = mapDispatchToProps;

export default connect(
  mapStateToPropsPeriodicityAttentionList,
  mapDispatchToPropsPeriodicityAttentionList
)(View);
